import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const Container = styled.div`
    min-width: 198px;
    color: ${colorsPalettes.carbon[0]};
`;

const Label = styled.p`
    margin: 0 0 2px;
    font-size: 0.815rem;
`;

export const Title = styled(Label)`
    font-weight: 700;
`;

export const ItemName = styled(Label)`
    font-weight: 400;
`;
